import LoadingButtonMui from '@mui/lab/LoadingButton'

import styles from './styles.module.scss'

export const LoadingText = () => {
  return (
    <LoadingButtonMui loading className={styles.loading}>
      <span>carregando</span>
    </LoadingButtonMui>
  )
}
